import { Component, OnInit, Input } from '@angular/core';
import { DependenciaModel } from 'src/app/models/dependencia.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlService } from 'src/app/shared/services/url.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { GlobalService } from 'src/app/shared/global.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { reporteInformeVisitante } from 'src/app/models/reporteInformeVisitante.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { HttpResponseBase } from '@angular/common/http';
import { UtilService } from 'src/app/shared/services/util.service';

@Component({
    selector: 'app-generar-reportes-informe-visitante',
    templateUrl: './generar-reporte-informe-visitante.component.html',
    styleUrls: ['./../generar-reporte.component.scss']
})

export class GenerarReporteInformeVisitanteComponent implements OnInit {

    @Input() public dependencia: DependenciaModel[];
    @Input() reporteInformeVisitante: reporteInformeVisitante[];

    public sede: string;
    public filtroDependencia: string;
    public filtroDocumento: string;
    public filtroSede: string;
    // public filtroFechaFin: string;
    // public filtroFechaInicio: string;
    public filtroFechaFin: Date;
    public filtroFechaInicio: Date;
    public filtroRol: string;
    public filtroDocumentoRol: string;
    public validar = true;
    public datosArchivo: any;
    public placeholderDate: string;

    constructor(
        private global: GlobalService,
        private urlService: UrlService,
        private spinner: NgxSpinnerService,
        private alertService: AlertService,
        private utilService: UtilService
    ) {
        this.filtroRol = sessionStorage.getItem(ConstantesService.ROL_SESSION);
        this.filtroDocumentoRol = sessionStorage.getItem(ConstantesService.NUM_DOC_SESSSION);
    }

    ngOnInit() {
        this.placeholderDate = ConstantesService.SELECCION_FECHA;
        this.filtroFechaFin = undefined;
        this.obtenerSede();
        this.getDependencias();
    }

    /**
     * Consulta los tipo de Sedes Existente
     */
    public obtenerSede() {
        this.spinner.show();
        const serviceProvider = 'ObtenerDominio';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'Sede']);
        const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.sede = data;
                this.spinner.hide();
            }, err => {
                this.cathException('No es posible Obtener las Sedes');
            }
        );
    }

    /**
     * Consulta el tipo de Dependencias Existentes
     */
    getDependencias() {
        this.spinner.show();
        const serviceProvider = 'ObtenerDependencias';
        const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.dependencia = data;
                this.spinner.hide();
            }, err => {
                this.cathException('No es posible Cargar las Dependencias');
            }
        );
    }

    /**
     * Método que recolecta los filtros y realiza el llamado del servicio correspondiente
     * al BACKEND y obtiene el resultado de la consulta deseada
     */
    GenerarReporteInformeVisitante() {
        this.validacion();

        if (!this.validar) {
            this.spinner.show();
            if (this.filtroDocumento && this.filtroDocumento.length > 0 && !/^([A-Z0-9])*$/.test(this.filtroDocumento)) {
                this.cathException('Por favor ingrese nuevamente un “Número de documento”');
                this.cathException('La información ingresada en “Número de documento”'
                    + 'no corresponde con lo solicitado, por favor verifique');
                document.getElementById('numeroDocumento').focus();
                return;
            }

            const filtros = {
                filtroDocumento: this.filtroDocumento,
                filtroDependencia: this.filtroDependencia,
                filtroSede: this.filtroSede,
                filtroFechaInicio: this.filtroFechaInicio,
                filtroFechaFin: this.filtroFechaFin,
                filtroRol: this.filtroRol,
                filtroDocumentoRol: this.filtroDocumentoRol
            };
            const serviceProvider = 'reporteInformeVisitante';
            const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);
            this.global.postGenerico(url, filtros).subscribe(
                data => {
                    this.datosArchivo = data;
                    this.spinner.hide();
                    this.alertService.generateAlertSuccess('Su reporte se está descargando', '');
                    this.descargarArchivo();
                }, err => {
                    if (err.status === 500) {
                        this.cathException(err.error.message);
                    } else {
                        this.cathException('El reporte no se ha podido generar');
                    }
                }
            );
        }
    }

    /**
     * Método que convierte el archivo Excel y realiza la descarga del mismo
     */
    descargarArchivo() {
        ConstantesService.descargarDocumento('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            , this.datosArchivo.nombre, this.datosArchivo.archivo);
        this.spinner.hide();
    }

    /**
     * Metodo que valida los campos obligatorios para porder habilitar el boton Generar Reporte
     */
    validacion() {
        if (this.utilService.validarCamposObligatorios(this.filtroFechaInicio)
            && this.utilService.validarCamposObligatorios(this.filtroFechaFin)) {
            this.validar = false;
        } else {
            this.validar = true;
        }
        if (this.filtroDocumento === '') {
            this.filtroDocumento = undefined;
        }
        if (this.filtroDependencia === 'undefined') {
            this.filtroDependencia = undefined;
        }
        if (this.filtroSede === 'undefined') {
            this.filtroSede = undefined;
        }
    }

    // /**
    //  * Método que valida la fecha Inicial y la anexa a una variable especifica filtroFechaInicio
    //  * @param event resive la fecha seleccionada por el usuario
    //  */
    // public handlerDatePickeRInicio(event) {
    //     this.filtroFechaInicio = this.utilService.convertirFechaConcatenada(event);
    // }

    // /**
    //  * Método que valida la fecha Final y la anexa a una variable especifica filtroFechaFin
    //  * @param event resive la fecha seleccionada por el usuario
    //  */
    // public handlerDatePickeRFin(event) {
    //     this.filtroFechaFin = this.utilService.convertirFechaConcatenada(event);
    // }

    /**
     * Método de control de Excepciones
     * @param error                 mensaje saliente respecto al error ocurrido
     * @param err: HttpResponseBase Tipo de error
     */
    cathException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spinner.hide();
    }
}
